/**
 * @file ContactView.tsx
 *
 * @fileoverview Shows a contact page layout for an anonymous users.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import Layout from '~/jobiqo/components/Layout';
import EntityForm from '~/jobiqo/components/Form/EntityForm';
import { useGdprConsentContext } from '../../GDPRConsent/hooks/useGdprConsentContext';
import GDPRConsentFormWrapper from '../../GDPRConsent/components/FormWrapper';
import GdprConsentCheckboxes from '../../GDPRConsent/components/Checkboxes';
import { Box } from '~/vcl/atoms/07-box';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { getGroup } from '~/jobiqo/utils/config';

interface ContactViewProps {
  /**
   * The onSubmit callback.
   */
  onSubmit: (formData) => void;
  /**
   * The list of field errors from the backend.
   */
  fieldErrorList?: any[];
}

export function ContactView({ onSubmit, fieldErrorList }: ContactViewProps) {
  const intl = useIntl();
  const { consentsValidation } = useGdprConsentContext();
  const { APP } = useFrontendConfig();
  // Keep the group so the app.js field order is respected, but without a label
  // so the form keeps its single-column layout.
  const CONTACT_FORM = {
    ...getGroup({ ...APP.FIELD_INFO.contact_form }),
    name: '',
  };

  return (
    <Layout mainContentSize="small">
      <Box
        label={intl.formatMessage({
          id: 'contact_label',
          defaultMessage: 'Send a contact message',
        })}
      >
        <GDPRConsentFormWrapper consentPlacement="CONTACT">
          <EntityForm
            name="contact_message"
            bundle="feedback"
            fieldGroups={[CONTACT_FORM]}
            extraInitialValues={consentsValidation.initialValues}
            extraValidationSchema={{
              ...consentsValidation.schema,
            }}
            formGroupsChildren={{
              contact_form: ({}) => (
                <>
                  <GdprConsentCheckboxes />
                </>
              ),
            }}
            onSubmit={onSubmit}
            fieldErrorList={fieldErrorList}
          />
        </GDPRConsentFormWrapper>
      </Box>
    </Layout>
  );
}
export default ContactView;
